import React, { useState } from "react";
import { createAccount } from "../../apis/Auth.Api";
import { FaTimesCircle } from "react-icons/fa";
import { InfoBlock, RectBtn } from "../../components/General";
import PopUp from "../../components/PopUp";
import { FormControl, FormHelperText, MenuItem, Select, TextField } from "@mui/material";
import { PERMISSION } from "../../configs/global";
import { useSelector } from "react-redux";
import { selectUserData } from "../../features/store";
import { useSnackbar } from "notistack";
const CreateAccountPopUp = ({ openAdd, setOpenAdd, users, setUsers }) => {
    const userData = useSelector(selectUserData);
    const { enqueueSnackbar } = useSnackbar();
    const [newAccountId, setNewAccountId] = useState(-1); // -1, -2, ...
    const [addName, setAddName] = useState("");
    const [addPermission, setAddPermission] = useState("");
    const [addId, setAddId] = useState("");

    const [validateName, setValidateName] = useState("");
    const [validatePermission, setValidatePermission] = useState("");
    const [validateId, setValidateId] = useState("");

    function validateInput() {
        let valid = true;
        let validId = true;
        if (addId === "") {
            setValidateId("Id cannot be empty");
            valid = false;
            validId = false;
        }
        if (addName === "") {
            setValidateName("Name cannot be empty");
            valid = false;
        }
        if (addPermission === "") {
            setValidatePermission("Permission cannot be empty");
            valid = false;
        }
        if (validId) {
            for (let user of users) {
                if (user.userId === addId) {
                    setValidateId("User ID already exist");
                    valid = false;
                }
            }
        }
        if (valid) {
            setValidateId("");
            setValidateName("");
            setValidatePermission("");
        }

        return valid;
    }
    async function confirmAddAccount() {
        let valid = validateInput();
        if (!valid) return;
        let r = await createAccount({ user_id: addId, user_name: addName, permission: addPermission });
        if (!r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        enqueueSnackbar(r.data.message, { variant: "success" });
        const newUsers = [...users];
        const newUser = {
            id: newAccountId,
            userId: addId,
            name: addName,
            reset: true,
            permission: addPermission,
        };
        setNewAccountId(newAccountId - 1);
        newUsers.unshift(newUser);
        setUsers(newUsers);
        setAddName("");
        setAddId("");
        setAddPermission("");

        setOpenAdd(false);
    }

    return (
        <PopUp width={60} height={60} switchOn={openAdd}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Add Account</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setAddName("");
                            setAddId("");
                            setAddPermission("");
                            setValidateId("");
                            setValidateName("");
                            setValidatePermission("");
                            setOpenAdd(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="add-account-content-wrapper">
                        <div className="fields">
                            <InfoBlock title={"User ID"}>
                                <TextField
                                    inputProps={{ maxLength: 20 }}
                                    value={addId}
                                    onChange={(e) => {
                                        setAddId(e.target.value);
                                    }}
                                    sx={{ minWidth: 200 }}
                                    placeholder="Enter unique id"
                                    error={validateId !== ""}
                                    helperText={validateId}
                                />
                            </InfoBlock>
                            <InfoBlock title={"Display Name"}>
                                <TextField
                                    inputProps={{ maxLength: 20 }}
                                    value={addName}
                                    onChange={(e) => {
                                        setAddName(e.target.value);
                                    }}
                                    sx={{ minWidth: 200 }}
                                    placeholder="Enter preferred name"
                                    error={validateName !== ""}
                                    helperText={validateName}
                                />
                            </InfoBlock>

                            <InfoBlock title={"Permission Level"}>
                                <FormControl sx={{ minWidth: 200 }} error={validatePermission !== ""}>
                                    <Select
                                        labelId="demo-select-small-label"
                                        id="demo-select-small"
                                        value={addPermission}
                                        onChange={(e) => {
                                            setAddPermission(e.target.value);
                                        }}
                                    >
                                        {userData.permission === PERMISSION.SUPER && (
                                            <MenuItem value={PERMISSION.SUPER}>0 - Super Admin</MenuItem>
                                        )}
                                        <MenuItem value={PERMISSION.ADMIN}>1 - Admin</MenuItem>
                                        <MenuItem value={PERMISSION.MANAGER}>2 - Manager</MenuItem>
                                        <MenuItem value={PERMISSION.VIEWER}>3 - Viewer</MenuItem>
                                    </Select>
                                    <FormHelperText>{validatePermission}</FormHelperText>
                                </FormControl>
                            </InfoBlock>
                        </div>

                        <div>
                            <RectBtn onClick={confirmAddAccount}>Confirm</RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default CreateAccountPopUp;
